var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fs-16 fc-white"},[_c('div',{staticClass:"bg-f4f9f9 p10"},[_c('div',{staticClass:"relative banner"},[_c('div',{staticClass:"line-height110 relative z-index1"},[_c('div',[_vm._v("提现银行")]),_c('div',[_vm._v(_vm._s(_vm.msg))])]),_c('img',{staticClass:"absolute banner_img",attrs:{"src":_vm.dealBanner,"alt":"银行卡"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }